module.exports = __webpack_public_path__ + "img/SU3F1_new.42d69e78.jpg";